import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ROUTE_CONSTANTS } from './constants/route.constants';

import { ComponentDeactivationService } from './services/component-deactivation.service';

import { LandingComponent } from './components/landing/landing.component';
import { MaatAuditPlanListComponent } from './components/maat-audit-plan-list/maat-audit-plan-list.component';
import { MaatJobListComponent } from './components/maat-job-list/maat-job-list.component';
import { MaatJobItemListComponent } from './components/maat-job-item-list/maat-job-item-list.component';
import { MaatNcqListComponent } from './components/maat-ncq-list/maat-ncq-list.component';
import { MaatNcqComponent } from './components/maat-ncq/maat-ncq.component';
import { MaatUserListComponent } from './components/maat-user-list/maat-user-list.component';
import { MaatUserComponent } from './components/maat-user/maat-user.component';
import { MaatSorDescriptionListComponent } from './components/maat-sor-description-list/maat-sor-description-list.component';
import { MaatSorDescriptionComponent } from './components/maat-sor-description/maat-sor-description.component';
import { OrganisationListComponent } from './components/organisation-list/organisation-list.component';
import { TeamListComponent } from './components/team-list/team-list.component';
import { UserListComponent } from './components/user-list/user-list.component';
import { OrganisationComponent } from './components/organisation/organisation.component';
import { TeamComponent } from './components/team/team.component';
import { InspectionListComponent } from './components/inspection-list/inspection-list.component';
import { InspectionComponent } from './components/inspection/inspection.component';
import { UserComponent } from './components/user/user.component';
import { NotificationListComponent } from './components/notification-list/notification-list.component';
import { ReportListComponent } from './components/report-list/report-list.component';
import { AuditListComponent } from './components/audit-list/audit-list.component';
import { BatchListComponent } from './components/batch-list/batch-list.component';
import { SyncEntityListComponent } from './components/sync-entity-list/sync-entity-list.component';
import { InspectionCalendarComponent } from './components/inspection-calendar/inspection-calendar.component';

const routes: Routes = [
  {
    // Loading root of site will redirect to...
    path: ROUTE_CONSTANTS.root,
    component: LandingComponent
  },
  // MaatAuditPlan
  {
    path: ROUTE_CONSTANTS.maatAuditPlan.list,
    component: MaatAuditPlanListComponent
  },
  // MaatJob
  {
    path: ROUTE_CONSTANTS.maatJob.list,
    component: MaatJobListComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // MaatJobItem
  {
    path: ROUTE_CONSTANTS.maatJobItem.list,
    component: MaatJobItemListComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // MaatNcq
  {
    path: ROUTE_CONSTANTS.maatNcq.list,
    component: MaatNcqListComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.maatNcq.new,
    component: MaatNcqComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.maatNcq.edit,
    component: MaatNcqComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // MaatUser
  {
    path: ROUTE_CONSTANTS.maatUser.list,
    component: MaatUserListComponent
  },
  {
    path: ROUTE_CONSTANTS.maatUser.edit,
    component: MaatUserComponent,
    canDeactivate: [ComponentDeactivationService],
  },
  // MaatSorDescription
  {
    path: ROUTE_CONSTANTS.maatSorDescription.list,
    component: MaatSorDescriptionListComponent
  },
  {
    path: ROUTE_CONSTANTS.maatSorDescription.prefix,
    component: MaatSorDescriptionComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.maatSorDescription.edit,
    component: MaatSorDescriptionComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  // Inspection
  {
    path: ROUTE_CONSTANTS.inspection.list,
    component: InspectionListComponent
  },
  {
    path: ROUTE_CONSTANTS.inspection.listForBatch,
    component: InspectionListComponent
  },
  {
    path: ROUTE_CONSTANTS.inspection.edit,
    component: InspectionComponent,
    canDeactivate: [ComponentDeactivationService]
  },  
  {
    path: ROUTE_CONSTANTS.inspection.calendar,
    component: InspectionCalendarComponent
  },
  // Organisation
  {
    path: ROUTE_CONSTANTS.organisation.list,
    component: OrganisationListComponent
  },
  {
    path: ROUTE_CONSTANTS.organisation.prefix,
    component: OrganisationComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.organisation.edit,
    component: OrganisationComponent,
    canDeactivate: [ComponentDeactivationService],
  },
  // Team
  {
    path: ROUTE_CONSTANTS.team.list,
    component: TeamListComponent
  },
  {
    path: ROUTE_CONSTANTS.team.prefix,
    component: TeamComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.team.edit,
    component: TeamComponent,
    canDeactivate: [ComponentDeactivationService],
  },
  // User
  {
    path: ROUTE_CONSTANTS.user.list,
    component: UserListComponent
  },
  {
    path: ROUTE_CONSTANTS.user.prefix,
    component: UserComponent,
    canDeactivate: [ComponentDeactivationService]
  },
  {
    path: ROUTE_CONSTANTS.user.edit,
    component: UserComponent,
    canDeactivate: [ComponentDeactivationService],
  },
  // Notification
  {
    path: ROUTE_CONSTANTS.notification.list,
    component: NotificationListComponent,
  },
  // Report
  {
    path: ROUTE_CONSTANTS.report.list,
    component: ReportListComponent
  },
  // Audit
  {
    path: ROUTE_CONSTANTS.audit.list,
    component: AuditListComponent
  },
  // Batch
  {
    path: ROUTE_CONSTANTS.batch.list,
    component: BatchListComponent
  },
  // Sync
  {
    path: ROUTE_CONSTANTS.syncEntity.list,
    component: SyncEntityListComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
